import * as React from 'react'
import { parseISO, parse, formatISO } from 'date-fns'
import { IErrorInfo } from './ErrorAlert';

declare global {
   var requestCount: number;
}

export function formatDate(input?: string) {
   return (input) ? formatISO(parseISO(input), { representation: 'date' }) : null;
}

export function formatDateString(input?: string) {
   return (input) ? formatISO(parse(input, "yyyyMMddHHmmss", new Date()), { representation: 'date' }) : null;
}

export async function readResponseBody(url : string, response : any) {
   const content = response.headers.get("Content-Type");

   if (content && content.indexOf("json") < 0) {
      console.error("URL: " + url);
      console.error("UnexpectedResponse: " + await response.text());
      return null;
   }

   return await response.json();
}

export async function httpGet(url: string, controller: AbortController) {
   try {
      console.info(`httpGet (${globalThis.requestCount++}): ${url}`);
      const response = await fetch(url, (controller) ? { signal: controller.signal } : {});
      if (response.redirected) {
         console.info(`httpRedirect: ${response.url}`);
         window.location.href = response.url;
      }
      else if (response.ok) {
         const body = await readResponseBody(url, response);
         if (body && !body.failed) {
            return body;
         }
         else {
            console.info(`httpGet: ${body?.errorCode} ${body?.errorText}`);
            return {
               failed: true,
               errorCode: body?.errorCode,
               errorText: body?.errorText
            }
         }
      }
      else {
         console.info(`httpGet: ${response.status} ${response.statusText}`);
         return {
            failed: true,
            errorCode: `HTTP ${response.status}`,
            errorText: response.statusText
         }
      }
   }
   catch (exception : any) {
      if (exception.code) {
         console.info(`httpGet: ${exception.code} ${exception.message}`);
         return {
            failed: true,
            errorCode: exception.code,
            errorText: exception.message,
            silent: exception.code === 20 // suppress aborts.
         }
      } else {
         console.info(`httpGet: UnexpectedError ${exception}`);
         return {
            failed: true,
            errorCode: 'UnexpectedError',
            errorText: exception.toString()
         }
      }
   }
}

export async function httpPost(url: string, item : any, controller : AbortController) {
   try {
      const requestOptions = {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify((item.toJson) ? item.toJson(item) : item),
         signal: controller?.signal
      };

      console.info(`httpPost: ${url}`);
      console.info("BODY: " + requestOptions.body);
      const response = await fetch(url, requestOptions);
      if (response.redirected) {
         console.info(`httpRedirect: ${response.url}`);
         window.location.href = response.url;
      }
      else if (response.ok) {
         const body = await readResponseBody(url, response);
         if (body && !body.failed) {
            return body;
         }
         else {
            console.info(`httpPost: ${body?.errorCode} ${body?.errorText}`);
            return {
               failed: true,
               errorCode: body?.errorCode,
               errorText: body?.errorText
            }
         }
      }
      else {
         console.info(`httpPost: ${response.status} ${response.statusText}`);
         return {
            failed: true,
            errorCode: `HTTP ${response.status}`,
            errorText: response.statusText
         }
      }
   }
   catch (exception : any) {
      if (exception.code) {
         console.info(`httpPost: ${exception.code} ${exception.message}`);
         return {
            failed: true,
            errorCode: exception.code,
            errorText: exception.message,
            silent: exception.code === 20 // suppress aborts.
         }
      } else {
         console.info(`httpPost: UnexpectedError ${exception}`);
         return {
            failed: true,
            errorCode: 'UnexpectedError',
            errorText: exception.toString()
         }
      }
   }

   return item;
}

//a
export function getQueryRunner(queryStr: string, setResponse: React.Dispatch<React.SetStateAction<any>>, setError: React.Dispatch<React.SetStateAction<IErrorInfo | null>>) {
   return () => {
       let abortController = new AbortController();

       fetch();

       async function fetch() {
           let response = await httpGet(queryStr, abortController);

           if(response?.errorCode) {
               setResponse([]);
               setError(response);
           }
           else {
               setResponse(response?.result);
               setError(null);
           }
       }

       return function cleanup() {
           abortController.abort();
       }
   }
}

export function runHttpQuery(queryStr: string, setResponse: React.Dispatch<React.SetStateAction<any>>, setError: React.Dispatch<React.SetStateAction<IErrorInfo | null>>) {
   const abortController = new AbortController();

   fetch();

   async function fetch() {
      let response = await httpGet(queryStr, abortController);

      if(response?.errorCode) {
          setResponse([]);
          setError(response);
      }
      else {
          setResponse(response?.result);
          setError(null);
      }
  }
}